<template>
  <div class="outer" :class="{portrait, one, two, rounded, imgBorder}">
    <div class="previews">
      <img @load="imgLoad" :src="previewUrls[0]">
      <img :src="previewUrls[1]" v-if="previewUrls[1]">
    </div>
    <div v-if="editButton" class="button-holder">
      <button @click="$emit('edit')" class="btn edit-design"><i class="far fa-edit"/> Edit Design</button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scss/colors';

.outer {
  // Allow the component to be centered easily
  display: inline-block;
  width: 100%;

  // landscape
  max-width: 504px;

  img {
    // Landscape or single portrait
    width: 100%;
    background: white;
  }

  &.imgBorder img {
    border: 1px solid $gray-1;
  }
  &.roundedCorners img {
    border-radius: 18px;
  }

  .previews {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  &.portrait {
    &.one {
      max-width: calc(253px);
    }
    &.two {
      // limit the container to the observed width of portrait cards,
      // plus a gap.
      max-width: calc(253px * 2 + 10px);
      img {
        width: calc(50% - 5px);
      }
    }

    .previews {
      flex-direction: row;
    }
  }

  // Ensure the "edit design" button, if present, is flush right
  // with the card.
  .button-holder {
    text-align: right;
    button {
      padding-right: 0;
    }
  }
}
</style>

<script>
export default {
  props: ['previewUrls', 'rounded', 'imgBorder', 'editButton'],
  data() {
    return {portrait: false}
  },
  computed: {
    one() {
      // One card
      return !this.previewUrls[1];
    },
    two() {
      // Two cards
      return !!this.previewUrls[1];
    }
  },
  methods: {
    imgLoad(evt) {
      this.portrait = (evt.target.naturalWidth < evt.target.naturalHeight);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/SideBySidePreview.vue